import React from 'react';
import { LoadingSpinner } from '@kcd/design-system';

import styles from './LoadingSpinnerCenter.module.css';

const LoadingSpinnerCenter = (
  props: React.ComponentProps<typeof LoadingSpinner>,
) => {
  return (
    <LoadingSpinner
      size={32}
      verticalCenter
      className={styles.spinner}
      {...props}
    />
  );
};

export default LoadingSpinnerCenter;
